import { AlertCircle } from 'lucide-react';
import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

export interface FieldErrorProps extends HTMLAttributes<HTMLDivElement> {
  message: string;
  size?: 'sm' | 'md';
}

export const FieldError = forwardRef<HTMLDivElement, FieldErrorProps>(
  ({ message, size = 'sm', className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'error-animate flex items-start gap-1.5 rounded-md border border-destructive/20 bg-destructive/5 px-2 py-1.5 text-destructive',
          size === 'sm' && 'text-xs',
          size === 'md' && 'text-sm',
          className
        )}
        role="alert"
        aria-live="polite"
        {...props}
      >
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
        <span className="leading-tight">{message}</span>
      </div>
    );
  }
);

FieldError.displayName = 'FieldError';
